exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titulos-contenedores {\r\n    color: #004165;\r\n    margin: 0px;\r\n    font-weight: 200;\r\n    padding: 20px 0px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.titulos-contenedores span {\r\n    font-size: 50px;\r\n    font-weight: bold;\r\n}\r\n\r\n.isDisabled {\r\n    color: currentColor;\r\n    cursor: not-allowed;\r\n    opacity: 0.5;\r\n    text-decoration: none;\r\n  }\r\n\r\n@media (max-width: 767px) {\r\n    .show-sm-down {\r\n        display: block !important;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/app/view/menu/menu.component.css
// module id = ../../../../../src/app/view/menu/menu.component.css
// module chunks = main